import { useAuth } from 'context/AuthProvider.js';
import { ApiEndpoint } from 'helpers/ApiEndPoint.js';
import { httpClient } from 'helpers/HttpClient.js';
import MyModal from 'helpers/MyModal.js';
import React, { useEffect, useState } from 'react';
import StatusTable from './_StatusTable.js';
import EditStatus from './_EditStatus.js';
const URI = ApiEndpoint + 'configuration/';

const Status = () => {
  const Auth = useAuth();
  var userData = Auth.getSessionData();
  const [openModal, setOpenModal] = useState(false);
  const [statuses, setStatuses] = useState(false);

  const [idStatusEdit, setIdStatusEdit] = useState(false);
  const handleClose = () => {
    setOpenModal(false);
    getStatusList();
  };

  const getStatusList = async () => {
    console.log('entre a getCitiesList');
    setStatuses(null);

    httpClient('GET', URI + 'status/', {}, userData.token)
      .then(function (response) {
        if (!response.data.error) {
          setStatuses(response.data);
        }
      })
      .catch(function (error) {
        console.log(error);
      })
      .finally(() => {});
  };

  useEffect(() => {
    getStatusList();
  }, []);
  return (
    <>
      {statuses && (
        <StatusTable
          status={statuses}
          setIdStatus={setIdStatusEdit}
          setOpenModal={setOpenModal}
        ></StatusTable>
      )}
      {/* {openConfirm && (
          <ConfirmAction
            message={'Desea eliminar el registro?'}
            title={'Confirmacion'}
            handleClose={handleCloseConfirm}
            open={openConfirm}
            ConfirmAction={DeleteConfirmed}
          ></ConfirmAction>
        )} */}
      {openModal && (
        <MyModal
          id="id_myModal"
          title={(idStatusEdit > 0 ? 'Editar' : 'Agregar') + ' Status'}
          openModal={openModal}
          closeModal={handleClose}
        >
          <></>
          <EditStatus
            closeModal={handleClose}
            idStatus={idStatusEdit}
          ></EditStatus>
        </MyModal>
      )}
    </>
  );
};

export default Status;
